import { EgretLoadable } from "egret";
import ConstantList from "app/appConfig";

const PatientMedicationHistoryIndex = EgretLoadable({
  loader: () => import("./PatientMedicationHistoryIndex"),
});
const Routes = [
  {
    path: ConstantList.ROOT_PATH + "patient/medication-history/:id",
    exact: true,
    component: PatientMedicationHistoryIndex,
    settings: { layout1Settings: { leftSidebar: { mode: "close" } } }
  },
];

export default Routes;
